__turbopack_context__.v({
  "layout": "qn6vAW_layout",
  "layout__body": "qn6vAW_layout__body",
  "layout__body--center": "qn6vAW_layout__body--center",
  "layout__content": "qn6vAW_layout__content",
  "layout__content--center": "qn6vAW_layout__content--center",
  "layout__header": "qn6vAW_layout__header",
  "layout__main": "qn6vAW_layout__main",
  "layout__sidebar": "qn6vAW_layout__sidebar",
});
